module.exports = __webpack_public_path__ + "img/baptistlogo.74461f8d.png";